export default __webpack_public_path__ + "static/media/13.b41463e8.jpg";